import type { TTeamConfig } from "src/shared/types/teamConfig.types";
import { dbacks_postseason } from "./dbacks_postseason/dbacks_postseason";
import { knicks } from "./knicks/knicks";
import { orlandomagic_pass } from "./orlandomagic_pass/orlandomagic_pass";
import { pass_check_in } from "./pass_check_in/pass_check_in";
import { pass_sandbox } from "./pass_sandbox/pass_sandbox";
import { pass_test } from "./pass_test/pass_test";
import { predators_upgrades } from "./predators_upgrades/predators_upgrades";
import { sacramentokings_pass } from "./sacramentokings_pass/sacramentokings_pass";
import { sacramentokings_sandbox } from "./sacramentokings_sandbox/sacramentokings_sandbox";
import { sanjosesharks_pass } from "./sanjosesharks_pass/sanjosesharks_pass";
import { stlouisblues_pass } from "./stlouisblues_pass/stlouisblues_pass";
import { washingtonwizards_pass } from "./washingtonwizards_pass/washingtonwizards_pass";
import { seatgeek_sandbox } from "./seatgeek_sandbox/seatgeek_sandbox";
import { sanantoniospurs_pass } from "./sanantoniospurs_pass/sanantoniospurs_pass";
import { azdbacks_pass } from "./azdbacks_pass/azdbacks_pass";
import { utahjazz_pass } from "./utahjazz_pass/utahjazz_pass";
import { tdc_sandbox_pass } from "./tdc_sandbox_pass/tdc_sandbox_pass";
import { kansascityroyals_pass } from "./kansascityroyals_pass/kansascityroyals_pass";
import { milwaukeebucks_pass } from "./milwaukeebucks_pass/milwaukeebucks_pass";
import { coloradorapids_pass } from "./coloradorapids_pass/coloradorapids_pass";
import { coloradorockies_pass } from "./coloradorockies_pass/coloradorockies_pass";
import { renoaces_pass_sandbox } from "./renoaces_pass_sandbox/renoaces_pass_sandbox";
import { renoaces_pass } from "./renoaces_pass/renoaces_pass";
import { azdbacks_upgrades } from "./azdbacks_upgrades/azdbacks_upgrades";
import { coloradorockies_upgrades } from "./coloradorockies_upgrades/coloradorockies_upgrades";
import { stlouiscardinals_themeupgrades } from "./stlouiscardinals_themeupgrades/stlouiscardinals_themeupgrades";
import { cincinnatireds_321tuesday } from "./cincinnatireds_321tuesday/cincinnatireds_321tuesday";
import { swbrailriders_pass } from "./swbrailriders_pass/swbrailriders_pass";
import { nyyankees_pass } from "./nyyankees_pass/nyyankees_pass";
import { pass_ekata } from "./pass_ekata/pass_ekata";
import { cincinnatireds_upgrades } from "./cincinnatireds_upgrades/cincinnatireds_upgrades";
import { woosox_studentpass } from "./woosox_studentpass/woosox_studentpass";
import { sacramentorivercats_pass } from "./sacramentorivercats_pass/sacramentorivercats_pass";
import { gwinnettstripers_pass } from "./gwinnettstripers_pass/gwinnettstripers_pass";
import { pdxtimbers_pass } from "./pdxtimbers_pass/pdxtimbers_pass";
import { jaguars } from "./jaguars/jaguars";
import { oregon_fanpass } from "./oregon_fanpass/oregon_fanpass";
import { saltlakebees_pass } from "./saltlakebees_pass/saltlakebees_pass";
import { romeemperors_pass } from "./romeemperors_pass/romeemperors_pass";
import { aviators_pass } from "./aviators_pass/aviators_pass";
import { alqisotopes_pass } from "./alqisotopes_pass/alqisotopes_pass";
import { atlantahawks_pass } from "./atlantahawks_pass/atlantahawks_pass";
import { atlantafalcons_pass } from "./atlantafalcons_pass/atlantafalcons_pass";
import { hvrenegades_pass } from "./hvrenegades_pass/hvrenegades_pass";
import { gators_pass } from "./gators_pass/gators_pass";
import { buckeyes_students } from "./buckeyes_students/buckeyes_students";
import { buckeyes_away } from "./buckeyes_away/buckeyes_away";
import { buckeyes_indianaaway } from "./buckeyes_indianaaway/buckeyes_indianaaway";
import { buckeyes_playoffs } from "./buckeyes_playoffs/buckeyes_playoffs";
import { buckeyes_texasaway } from "./buckeyes_texasaway/buckeyes_texasaway";
import { gators_students } from "./gators_students/gators_students";
import { stpaulsaints_pass } from "./stpaulsaints_pass/stpaulsaints_pass";
import { oregon_students } from "./oregon_students/oregon_students";
import { pass_bundles } from "./pass_bundles/pass_bundles";
import { gators_sandbox } from "./gators_sandbox/gators_sandbox";
import { buckeyes_sandbox } from "./buckeyes_sandbox/buckeyes_sandbox";
import { gators_staging } from "./gators_staging/gators_staging";
import { iowastate_cyclones } from "./iowastate_cyclones/iowastate_cyclones";
import { iowastate_upgrades } from "./iowastate_upgrades/iowastate_upgrades";
import { iowastate_studentathletes } from "./iowastate_studentathletes/iowastate_studentathletes";
import { usf_students } from "./usf_students/usf_students";
import { gators_studentathletes } from "./gators_studentathletes/gators_studentathletes";
import { gators_students_2 } from "./gators_students_2/gators_students_2";
import { sacramentokings_deltadental } from "./sacramentokings_deltadental/sacramentokings_deltadental";
import { knicks_gardendeck } from "./knicks_gardendeck/knicks_gardendeck";
import { iowastate_olympic } from "./iowastate_olympic/iowastate_olympic";
import { newmexicounited_pass } from "./newmexicounited_pass/newmexicounited_pass";
import { buckeyes_bball } from "./buckeyes_bball/buckeyes_bball";
import { coastalcredit_ancillary } from "./coastalcredit_ancillary/coastalcredit_ancillary";
import { coastalcredit_upgrades } from "./coastalcredit_upgrades/coastalcredit_upgrades";
import { sacramentokings_upgrades } from "./sacramentokings_upgrades/sacramentokings_upgrades";
import { pncmusicpavilion_upgrades } from "./pncmusicpavilion_upgrades/pncmusicpavilion_upgrades";
import { pncmusicpavilion_ancillary } from "./pncmusicpavilion_ancillary/pncmusicpavilion_ancillary";
import { cincinnatireds_321tuesday_sandbox } from "./cincinnatireds_321tuesday_sandbox/cincinnatireds_321tuesday_sandbox";
import { cincinnatireds_upgrades_sandbox } from "./cincinnatireds_upgrades_sandbox/cincinnatireds_upgrades_sandbox";
import { stlouiscardinals_themeupgrades_sandbox } from "./stlouiscardinals_themeupgrades_sandbox/stlouiscardinals_themeupgrades_sandbox";
import { northislandcreditunion_upgrades } from "./northislandcreditunion_upgrades/northislandcreditunion_upgrades";
import { northislandcreditunion_ancillary } from "./northislandcreditunion_ancillary/northislandcreditunion_ancillary";
import { oregon_basketball } from "./oregon_basketball/oregon_basketball";
import { iowastate_cyclonesbasketball } from "./iowastate_cyclonesbasketball/iowastate_cyclonesbasketball";
import { phoenixsuns_pass } from "./phoenixsuns_pass/phoenixsuns_pass";
import { phoenixsunsup_pass } from "./phoenixsunsup_pass/phoenixsunsup_pass";
import { fcs_pass } from "./fcs_pass/fcs_pass";
import { tm_sandbox_pass } from "./tm_sandbox_pass/tm_sandbox_pass";
import { albuquerqueisotopes_pass } from "./albuquerqueisotopes_pass/albuquerqueisotopes_pass";
import { cincinnatireds_memberpass } from "./cincinnatireds_memberpass/cincinnatireds_memberpass";
import { losangelesangels_pass } from "./losangelesangels_pass/losangelesangels_pass";
import { cincinnatireds_studentpass } from "./cincinnatireds_studentpass/cincinnatireds_studentpass";
import { lovb_madison } from "./lovb_madison/lovb_madison";
import { lovb_nebraska } from "./lovb_nebraska/lovb_nebraska";
import { miamiopen_upgrades } from "./miamiopen_upgrades/miamiopen_upgrades";
import { mlb_pass } from "./mlb_pass/mlb_pass";
import { texasrangers_pass } from "./texasrangers_pass/texasrangers_pass";
import { baltimoreravens_pass } from "./baltimoreravens_pass/baltimoreravens_pass";
import { newyorkmets_pass } from "./newyorkmets_pass/newyorkmets_pass";
import { newyorkmets_upgrades } from "./newyorkmets_upgrades/newyorkmets_upgrades";
import { losangelesangels_upgrades } from "./losangelesangels_upgrades/losangelesangels_upgrades";
import { northwestarkansasnaturals_pass } from "./northwestarkansasnaturals_pass/northwestarkansasnaturals_pass";
import { seattlesounders_pass } from "./seattlesounders_pass/seattlesounders_pass";
import { knicks_gardendeck_sandbox } from "./knicks_gardendeck_sandbox/knicks_gardendeck_sandbox";
import { newyorkyankees_upgrades } from "./newyorkyankees_upgrades/newyorkyankees_upgrades";
import { newyorkjets_upgrades } from "./newyorkjets_upgrades/newyorkjets_upgrades";
import { winnipegjets_pass } from "./winnipegjets_pass/winnipegjets_pass";
import { newyorkrangers_pass } from "./newyorkrangers_pass/newyorkrangers_pass";
import { clemsontigers_pass } from "./clemsontigers_pass/clemsontigers_pass";
import { riverhounds_pass } from "./riverhounds_pass/riverhounds_pass";
import { seattlesounders_flow } from "./seattlesounders_flow/seattlesounders_flow";
import { seattlesounders_upgrades } from "./seattlesounders_upgrades/seattlesounders_upgrades";
import { clemsontigersalumni_pass } from "./clemsontigersalumni_pass/clemsontigersalumni_pass";
import { reservation_sandbox_pass } from "./reservation_sandbox_pass/reservation_sandbox_pass";
import { tm_sandbox_marketplace } from "./tm_sandbox_marketplace/tm_sandbox_marketplace";
import { buckeyes_student } from "./buckeyes_student/buckeyes_student";
import { iowastatestudents_marketplace } from "./iowastatestudents_marketplace/iowastatestudents_marketplace";
import { gators_marketplace_sandbox } from "./gators_marketplace_sandbox/gators_marketplace_sandbox";
import { oregon_marketplace_sandbox } from "./oregon_marketplace_sandbox/oregon_marketplace_sandbox";

/**
 * Built on demand rather than at module evaluation time.
 *
 * There is a real import cycle here: teamConfigs -> each team config ->
 * (helper.tsx / useSSTheme) -> useTeamConfig -> TeamConfigProvider ->
 * teamConfigs. With the array built at module scope, evaluation order on a cold
 * start could capture bindings that were not initialized yet, leaving the array
 * incomplete. The lookup then missed the schema, useTeamConfig returned null,
 * and SSR crashed — over a hundred components destructure that return value with
 * no guard.
 *
 * Building inside the function moves the read to render time, once every module
 * has finished initializing. Intentionally not cached: the cost is negligible
 * and caching risks freezing an incomplete array.
 */
export function getTeamConfigs(): TTeamConfig[] {
  return [
    knicks,
    pass_test,
    stlouisblues_pass,
    sacramentokings_pass,
    pass_sandbox,
    sanjosesharks_pass,
    dbacks_postseason,
    washingtonwizards_pass,
    orlandomagic_pass,
    pass_check_in,
    seatgeek_sandbox,
    sacramentokings_sandbox,
    predators_upgrades,
    sanantoniospurs_pass,
    azdbacks_pass,
    utahjazz_pass,
    tdc_sandbox_pass,
    kansascityroyals_pass,
    milwaukeebucks_pass,
    coloradorapids_pass,
    coloradorockies_pass,
    renoaces_pass_sandbox,
    renoaces_pass,
    azdbacks_upgrades,
    coloradorockies_upgrades,
    stlouiscardinals_themeupgrades,
    cincinnatireds_321tuesday,
    swbrailriders_pass,
    nyyankees_pass,
    pass_ekata,
    cincinnatireds_upgrades,
    woosox_studentpass,
    sacramentorivercats_pass,
    gwinnettstripers_pass,
    pdxtimbers_pass,
    jaguars,
    oregon_fanpass,
    saltlakebees_pass,
    romeemperors_pass,
    aviators_pass,
    alqisotopes_pass,
    atlantahawks_pass,
    atlantafalcons_pass,
    hvrenegades_pass,
    gators_pass,
    buckeyes_students,
    buckeyes_student,
    iowastatestudents_marketplace,
    buckeyes_away,
    buckeyes_indianaaway,
    buckeyes_playoffs,
    buckeyes_texasaway,
    gators_students,
    stpaulsaints_pass,
    oregon_students,
    pass_bundles,
    gators_sandbox,
    buckeyes_sandbox,
    gators_staging,
    iowastate_cyclones,
    iowastate_upgrades,
    iowastate_studentathletes,
    usf_students,
    gators_studentathletes,
    gators_students_2,
    sacramentokings_deltadental,
    knicks_gardendeck,
    iowastate_olympic,
    newmexicounited_pass,
    buckeyes_bball,
    coastalcredit_ancillary,
    coastalcredit_upgrades,
    sacramentokings_upgrades,
    pncmusicpavilion_upgrades,
    pncmusicpavilion_ancillary,
    cincinnatireds_321tuesday_sandbox,
    cincinnatireds_upgrades_sandbox,
    stlouiscardinals_themeupgrades_sandbox,
    northislandcreditunion_upgrades,
    northislandcreditunion_ancillary,
    oregon_basketball,
    iowastate_cyclonesbasketball,
    phoenixsuns_pass,
    phoenixsunsup_pass,
    fcs_pass,
    tm_sandbox_pass,
    albuquerqueisotopes_pass,
    cincinnatireds_memberpass,
    losangelesangels_pass,
    cincinnatireds_studentpass,
    lovb_madison,
    lovb_nebraska,
    miamiopen_upgrades,
    mlb_pass,
    texasrangers_pass,
    baltimoreravens_pass,
    newyorkmets_pass,
    newyorkmets_upgrades,
    losangelesangels_upgrades,
    northwestarkansasnaturals_pass,
    seattlesounders_pass,
    knicks_gardendeck_sandbox,
    newyorkyankees_upgrades,
    newyorkjets_upgrades,
    winnipegjets_pass,
    newyorkrangers_pass,
    clemsontigers_pass,
    riverhounds_pass,
    seattlesounders_flow,
    clemsontigersalumni_pass,
    seattlesounders_upgrades,
    reservation_sandbox_pass,
    tm_sandbox_marketplace,
    gators_marketplace_sandbox,
    oregon_marketplace_sandbox,
  ].filter(Boolean);
}
